import { useCallback, useRef, useState } from "react";

/** Drives a section's Edit/Save button: starts read-only, `save` flips back to read-only on success. */
export function useSectionEditToggle() {
  const [editing, setEditing] = useState(false);
  const saving = useRef(false);

  const startEditing = useCallback(() => setEditing(true), []);

  const save = async (submit: () => Promise<void>) => {
    if (!editing) {
      setEditing(true);
      return;
    }
    if (saving.current) return;
    saving.current = true;
    try {
      await submit();
      setEditing(false);
    } finally {
      saving.current = false;
    }
  };

  return { editing, save, startEditing };
}
